import React from 'react'
import { DefaultButton } from 'office-ui-fabric-react/lib/Button'
import { Nav } from 'office-ui-fabric-react/lib/Nav';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { withContext, getContext, withHandlers,lifecycle } from 'recompose'
import PropTypes from 'prop-types'


/**
 * 
 * @param {*} param0 
 */
const Component = ({loadData, employees, employeeLinks}) => <div>
  <DefaultButton text="Load Employees" onClick={loadData('TST')} />
  {/*<Nav groups={[{links:employeeLinks }]} />*/}
  {JSON.stringify(employees)} 
</div>
 
/**** Selectors */
/**
 * 
 * @param {*} employees 
 */
const getEmployeeLinks = (employees) => {
  return employees 
    ? Object.entries(employees)
      .map( ([id,ee]) => ({ id, firstName: ee.firstName, lastName: ee.lastName }) )
      .sort( (a,b) => { 
        if (a.lastName < b.lastName) return -1
        if (a.lastName > b.lastName) return 1
        return 0
      }   )
      .map( ee => ({ name: ee.firstName + ' ' + ee.lastName }) )
    : []
}
const formatEmployees = (employees) => {
  return employees ? 'true': 'false'
}

/**** Containers */
const withStore = compose(
  withContext({ store: PropTypes.object }, () => {}),
  getContext({ store: PropTypes.object }),
  )

function mapStateToProps(state) {
  const { firestore } = state

  const employeeLinks = firestore.data.employees
    ? getEmployeeLinks(firestore.data.employees)
    : []

  return {
    employees: firestore.data.employees, // (object) // firestore.ordered.employees (array)
    //employeeLinks: getEmployeeLinks(firestore.data.employees)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const store = ownProps.store
  return {
    loadData: (companyId) => { store.firestore.get({ collection: 'employees', where: ['company.id','==',companyId ]})  
    }
  }
}
export default compose(
  withStore,
  connect(mapStateToProps,mapDispatchToProps)
)(Component)


// WEBPACK FOOTER //
// ./src/admin/containers/Employees.js